import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const TvDashboardEndPoints = {
  WS_DATA_URL: '',
  TV_DASHBOARD_IMG_URL: '',
  TV_DASHBOARD_IMG_ENDPOINT: '/dataman/getsiluhoutteimageDashBoard',
};

type TTvDashboardEndPoints = typeof TvDashboardEndPoints;
type TTvDashboardEndPointsTypes = keyof TTvDashboardEndPoints;

@Injectable({ providedIn: 'root' })
export class TvDashboardEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TTvDashboardEndPoints = {
    WS_DATA_URL: '',
    TV_DASHBOARD_IMG_URL: '',
    TV_DASHBOARD_IMG_ENDPOINT: '/dataman/getsiluhoutteimageDashBoard',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;

    this.registerVars(environment);
  }

  private registerVars(environment: TInputAppEnvironmentVars) {
    this.env_vars.WS_DATA_URL =
      environment.ws_protocol + environment.ws_host + environment.data_services + environment.ws_api;

    this.env_vars.TV_DASHBOARD_IMG_URL =
      environment.protocol +
      environment.ws_host +
      environment.app_img_service +
      this.env_vars.TV_DASHBOARD_IMG_ENDPOINT;
  }

  public getEnvVar(arg: TTvDashboardEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
